import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { share } from 'rxjs/operators'

@Injectable({
  providedIn: "root"
})
export class ConflictosService {
  constructor(private http: HttpClient) {}

  opcionesHttp = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };

  consultarPreguntas(IdConflictoIn) {
    let Data = {
      IdConflicto: IdConflictoIn
    };
    return this.http.post(`${environment.apiUrl}/Conflictos/ConsultarConflicto`, Data);
  }

  crearConflicto(idFuncionario, idConflicto, CamposObject,lugarConflicto) {
    
    let AnnioActual = new Date().getFullYear();
    
    let Data = {
      id_funcionario: idFuncionario,
      id_conflicto: idConflicto,
      estado: "1",
      annio: AnnioActual,
      es_nuevo: "1",
      lugarConflicto:lugarConflicto,
      CamposObject
    };
    return this.http.post(`${environment.apiUrl}/Conflictos/crearConflicto`, Data);
  }

  Actualizarfecha(idFuncionario) {            
    let Data = {
      idFuncionario
    };
    return this.http.post(`${environment.apiUrl}/Conflictos/Actualizarfecha`, Data);
  }

  actualizar_registro(idconflicto,id_usuario) {   
             
    let Data = {
      idconflicto,
      id_usuario,
      
    };
    return this.http.post(`${environment.apiUrl}/Conflictos/actualizar_registro`, Data);
  }


  crearRespuestaIndividual(idRespuesta,idTipoRespuesta,valor,lugarConflicto){
    let Data = {
      idRespuesta,
      idTipoRespuesta,
      valor,
      lugarConflicto
    };
    ////conole.log("DATA NUEVA ACTUALIZACION",Data)
    return this.http.post(`${environment.apiUrl}/Conflictos/NuevoCampoRespuesta`, Data);
  }

  consultarNumeroConflictosPorPregunta(idFuncionario) {
    let Data = {
      idFuncionario
    };
    return this.http.post(`${environment.apiUrl}/Conflictos/TiposConflictoCantidadRespuestas`, Data);
  }

  consultarRepuestas(idFuncionario, idConflicto) {
    let Data = {
      idFuncionario,
      idConflicto
    };
    return this.http.post(`${environment.apiUrl}/Conflictos/ConsultarRespuestas`, Data);
  }

  actualizarCampos(campos,lugarConflicto,conflicto) {
    let Data = {
      campos,
      lugarConflicto,
      conflicto,
    };
    return this.http.post(`${environment.apiUrl}/Conflictos/ActualizarCampos`, Data);
  }

  cerrarConflicto(idConflicto, idUsuario, justificacion,infoConflicto?,infoRespuesta?) {
    let Data = {
      idtbl_respuesta_conflicto: idConflicto,
      comentarios: justificacion,
      id_usuario_sistema: idUsuario,
      infoConflicto:infoConflicto,
      infoRespuesta:infoRespuesta,
    };

    //////conole.log(Data)
    return this.http.post(`${environment.apiUrl}/Conflictos/CerrarConflicto`, Data);
  }

  cargarDocusign(id_funcionario, IdConflicto, lenguaje){
    let Data = {
      IdFuncionario: id_funcionario,
      IdConflicto: IdConflicto,
      lenguaje: lenguaje
    }
    
    this.http.post(`${environment.apiUrl}/Preguntas/EnviarDocuSign`, Data).subscribe(r => {
      //////conole.log("Resultado docusign ", r);
    });
  }

  cargarDocusignBtn(id_funcionario, IdConflicto, lenguaje){
    let Data = {
      IdFuncionario: id_funcionario,
      IdConflicto: IdConflicto,
      lenguaje: lenguaje
    }
    
   return this.http.post(`${environment.apiUrl}/Preguntas/EnviarDocuSign`, Data)
  }


  cambiarEstadoConflicto(item){
    let Data={
      idRespuesta:item.idRespuesta,
      idOrigen:item.idOrigen
    }

    return this.http.post(`${environment.apiUrl}/Conflictos/CambiarEstadoEncuesta`, Data);
  }


  validarRegUnico(item){
    let Data={
      idConflicto:item.id_respuesta,
    }

    return this.http.post(`${environment.apiUrl}/Conflictos/validarRegistroUnico`, Data);
  }
}
